const ITEM_HEIGHT = 76;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export const currencyCodes = [
    "KZT",
    "USD",
    "EUR",
    "RUB",
    "CNY",
    "KGS",
    "TRY",
    "UZS",
    "AED",
    "GBP",
    "GEL",
    "CHF",
    "JPY",
    "KRW",
    "CAD",
    "INR",
    "THB",
    "VND",
    "EGP",
    "SAR",
    "TJS",
    "AZN",
    "AMD",
    "UAH",
    "CZK",
    "AUD",
    "DKK",
    "XDR",
    "HUF",
    "SGD",
    "ZAR",
    "NOK",
    "BYN",
    "SEK",
    "BRL",
    "MYR",
    "PLN",
    "MDL",
    "MXN",
    "HKD",
    "KWD",
    "IRR",
    "OMR",
    "IDR",
    "ILS",
];
export const goldCodes = ["GOLD5", "GOLD10", "GOLD20", "GOLD50", "GOLD100"];

export const regions: ["Алматы", "Астана", 'Актобе'] = ["Алматы", "Астана", 'Актобе'];

export const indivRates = {
    USD: 0.1,
    EUR: 0.1,
    RUB: 0.01,
    KGS: 0.01,
    CNY: 0.1,
    GBP: 1,
    CHF: 1,
};

export const employeePositions = [
    {
        position: "Кассир",
        code: 1,
    },
    {
        position: "Старший кассир",
        code: 2,
    },
    {
        position: "Директор",
        code: 3,
    },
    {
        position: "Бухгалтер",
        code: 4,
    },
    {
        position: "Главный бухгалтер",
        code: 5,
    },
    {
        position: "Казначей",
        code: 6,
    },
    {
        position: "Разработчик",
        code: 7,
    },
    {
        position: "Проектный менеджер",
        code: 8,
    },
    {
        position: "Менеджер",
        code: 9,
    },
];

export const employeePosition: Record<number, string> = {
    1: "Кассир",
    2: "Старший кассир",
    3: "Директор",
    4: "Бухгалтер",
    5: "Главный бухгалтер",
    6: "Казначей",
    7: "Разработчик",
    8: "Проектный менеджер",
};

export const employeeAttachment = {
    1: "Удостоверение личности",
    2: "Диплом",
    3: "Фото",
    4: "Банк",
    5: "Справка об отсутствии судимости",
    6: "Справка из психоневрологического диспансера",
    7: "Справка из наркологического диспансера",
    8: "Справка о прохождении обучения по работе с иностранной валютой",
    9: "Военный билет / приписное свидетельство",
    10: "РВП (разрешение на временное проживание)",
    11: "ВНЖ (вид на жительство)",
    // 12: "Заявление на прием сотрудника"
    // 13: "Согласие на сбор и обработку персональных данных"
    // 14: "Трудовой договор (срочный, 12 месяцев)"
    // 15: "Согласие о неразглашении"
    // 16: "Договор о полной материальной ответственности"
    // 17: "Договор о коллективной материальной ответственности"
};

export enum EmployeeAttachment {
    IdentityDocument = 1,
    EducationDiploma = 2,
    Photo = 3,
    Iban = 4,
    NoCriminalRecord = 5,
    PsychoDispanser = 6,
    NarcologyDispanser = 7,
    FxTrainingCertificate = 8,
    MilitaryId = 9,
    Rvp = 10,
    Vnzh = 11
}

export const employeeStatus: Record<number, string> = {
    1: "На оформлении",
    2: "На подтверждении у Директора",
    3: "Принят",
    4: "Уволен",
    5: "Отменен/не принят",
    6: "Отпуск по уходу за ребенком",
    7: "Подтвержден директором",
    8: "На подтверждении у Бухгалтера",
    9: "Ожидает документы у инициатора",
};

export enum EmployeeStatus {
    Registration = 1,        // на оформлении
    PendingConfirmation = 2, // на подтверждении
    Accepted = 3,            // принят
    Dismissed = 4,           // уволен
    Canceled = 5,            // отменен
    ParentalLeave = 6,       // отпуск по уходу за ребенком
    ConfirmedByDirector = 7, // подтвержден директором
    PendingAccountant = 8,   // на подтверждении у бухгалтера
    WaitingInitiatorDocs = 9 // ожидает документы у инициатора (2-й пакет)
}

export const bankList = [
    {
        name: "АО «Народный Банк Казахстана»",
        bin: "940140000385",
        bik: "HSBKKZKX",
    },
    {
        name: "АО «Kaspi Bank»",
        bin: "971240001315",
        bik: "CASPKZKA",
    },
];

export enum DocumentType {
    ID = "Удостоверение личности",
    PASSPORT = "Паспорт",
    RESIDENCE_PERMIT = "Вид на жительство",
    STATELESS_PASSPORT = "Удостоверение лица без гражданства",
    FOREIGN_PASSPORT = "Заграничный паспорт"
}

export const limitToIndivRate: { [key: string]: number } = {
    USD: 2000,
    EUR: 2000,
    RUB: 100000
};

export const ofdKassaInfo: Record<string, Record<number, { title: string, bin: string, address: string, kkm_serial_number: string, kkm_fns_kkm_id: string }>> = {
    RIXOS: {
        1: {
            title: "Товарищество с ограниченной ответственностью \"ECASH\"",
            bin: "221240028699",
            address: "г. Алматы, р-н Алмалинский, пр. Сейфулина, д.506/99",
            kkm_serial_number: "KTCD1142769759317",
            kkm_fns_kkm_id: "600704388045",
        }
    },
    "ГРАНД ПАРК": {
        6: {
            title: "Товарищество с ограниченной ответственностью \"ECASH 2\"",
            bin: "230840009643",
            address: "г. Алматы, Ауэзовский р-он, ул. Кабдолова, строение 1/4",
            kkm_serial_number: "KTCD1142769759317",
            kkm_fns_kkm_id: "600704388045",
        }
    },
    "АПОРТ": {
        5: {
            title: "Товарищество с ограниченной ответственностью \"ECASH 5\"",
            bin: "230840009643",
            address: "Алматинская обл., Карасайский р-он, с. Иргели, ул. Трасса Алматы Бишкек, д. 767",
            kkm_serial_number: "KTCD1142769759317",
            kkm_fns_kkm_id: "600704388045",
        }
    },
    "ЗЕЛЕНЫЙ БАЗАР": {
        3: {
            title: "Товарищество с ограниченной ответственностью \"ECASH\"",
            bin: "221240028699",
            address: "г. Алматы, Медеуский р-он, пр. Жибек Жолы 53 (мясной отдел 595, 1 этаж)",
            kkm_serial_number: "KTCD1142769759317",
            kkm_fns_kkm_id: "600704388045",
        }
    },
    "FORUM": {
        4: {
            title: "Товарищество с ограниченной ответственностью \"ECASH 6\"",
            bin: "240840001104",
            address: "г. Алматы, пр. СЕЙФУЛЛИНА, д. 617",
            kkm_serial_number: "KTCD1142769759317",
            kkm_fns_kkm_id: "600704388045",
        }
    },
    "MEGA PARK": {
        7: {
            title: "Товарищество с ограниченной ответственностью \"ECASH 6\"",
            bin: "240840001104",
            address: "г. Алматы, пр. СЕЙФУЛЛИНА, д. 617",
            kkm_serial_number: "KTCD1142769759317",
            kkm_fns_kkm_id: "600704388045",
        }
    },
};

export enum RolesEnum {
    Admin = "ADMIN",
    Cashier = "Cashier",
    Treasurer = "Treasurer",
    TreasurerViewer = "Treasurer_Viewer",
    Accountant = "Accountant",
    Director = "DIRECTOR",
    MainCashier = "Main_Cashier",
    Tablo = "Tablo",
    HR = "HR",
    NationalBank = "national_bank",
    Analyst = "analyst",
    Timesheet = "Timesheet",
    Franchise = "Franchise",
    AcceptTenant = "AcceptTenant",
    Manager = "Manager",
    CallCenter = "CallCenter"
}

export enum QueueEnum {
    CashTransfer = "cash_transfer",
    Accepts = "accepts",
    KassaDay = "kassa_day",
    CashierRequest = "cashier_request",
    CashRequest = "cash_request",
}

export enum AcceptsType {
    ReturnRequest = "return_request",
    AddCurrency = "add_currency",
    DeleteCurrency = "delete_currency",
    Bron = "bron",
}

export enum AcceptActionTypeBack {
    Reserve = 1, // Резервирование
    IndivRate = 2, // Индив курс
    Return = 3, // Возврат
    AddCurrency = 4, // Добавление валюты
    DeleteCurrency = 5, // Удаление валюты
}

export enum AcceptStatusBack {
    Created = 0, // Создана
    Assigned = 1, // Назначена
    Accepted = 2, // Подтверждена
    Rejected = 3 // Отказ
}

export enum RequestStatusEnum {
    Waiting = "waiting",
    AcceptedByTreasurer = "accepted_by_treasurer",
    Accepted = "accepted",
    Completed = "completed",
    Rejected = "rejected",
}

export const RequestStatus = [
    "Введен", // 0
    "Исполнено", // 1
    "Возврат", // 2
    "Отменён", // 3
    "Введен вне рабочее время", // 4
    "Ожидание", // 5
    "", // 6
    "Отмена перещения", // 7
    "Забронировано", // 8
    "Ожидайте клиента от Казначея", // 9
];

export const monthsArray = [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь"
];

export const regionKzArray = [
    { region: "Алматы", index: "050000", pkbRegion: "АЛМАТЫ", localities: ["Алатауский", "Алмалинский", "Ауэзовский", "Бостандыкский", "Жетысуский", "Медеуский", "Наурызбайский", "Турксибский"] },
    { region: "Астана", index: "010000", pkbRegion: "АСТАНА", localities: ["Алматы", "Байқоңыр", "Есильский", "Нұра", "Сарыарқа", "Сарайшық"] },
    { region: "Шымкент", index: "160000", pkbRegion: "ШЫМКЕНТ", localities: ["Абайский", "Аль-Фарабийский", "Енбекшинский", "Каратауский", "Туранский"] },
    { region: "Абайская обл", index: "040000", pkbRegion: "АБАЙСКАЯ", localities: ["Семей", "Курчатов"] },
    { region: "Алматинская обл", index: "040000", pkbRegion: "АЛМАТИНСКАЯ", localities: ["Конаев", "Каскелен", "Талгар", "Есик", "Уштобе"] },
    { region: "Акмолинская обл", index: "020000", pkbRegion: "АКМОЛИНСКАЯ", localities: ["Кокшетау", "Степногорск", "Щучинск", "Қосшы"] },
    { region: "Актюбинская обл", index: "030000", pkbRegion: "АКТЮБИНСКАЯ", localities: ["Актобе", "Кандыагаш", "Хромтау", "Шалкар"] },
    { region: "Атырауская обл", index: "060000", pkbRegion: "АТЫРАУСКАЯ", localities: ["Атырау", "Кульсары"] },
    { region: "Восточно-Казахстанская обл", index: "070000", pkbRegion: "В-КАЗАХСТАНСКАЯ", localities: ["Усть-Каменогорск", "Риддер", "Алтай", "Серебрянск"] },
    { region: "Жамбылская обл", index: "080000", pkbRegion: "ЖАМБЫЛСКАЯ", localities: ["Тараз", "Жанатас", "Каратау"] },
    { region: "Жетысуская обл", index: "040000", pkbRegion: "ЖЕТЫСУСКАЯ", localities: ["Талдыкорган", "Текели", "Ушарал"] },
    { region: "Западно-Казахстанская обл", index: "090000", pkbRegion: "З-КАЗАХСТАНСКАЯ", localities: ["Уральск", "Аксай"] },
    { region: "Карагандинская обл ", index: "100000", pkbRegion: "КАРАГАНДИНСКАЯ", localities: ["Караганда", "Темиртау", "Балхаш", "Сарань", "Шахтинск"] },
    { region: "Костанайская обл", index: "110000", pkbRegion: "КОСТАНАЙСКАЯ", localities: ["Костанай", "Рудный", "Лисаковск", "Аркалык"] },
    { region: "Кызылординская обл", index: "120000", pkbRegion: "КЫЗЫЛОРДИНСКАЯ", localities: ["Кызылорда", "Байконур", "Аральск", "Казалинск"] },
    { region: "Мангистауская обл", index: "130000", pkbRegion: "МАНГИСТАУСКАЯ", localities: ["Актау", "Жанаозен"] },
    { region: "Павлодарская обл", index: "140000", pkbRegion: "ПАВЛОДАРСКАЯ", localities: ["Павлодар", "Экибастуз", "Аксу"] },
    { region: "Северо-Казахстанская обл", index: "150800", pkbRegion: "С-КАЗАХСТАНСКАЯ", localities: ["Петропавловск", "Булаево", "Сергеевка"] },
    { region: "Туркестанская обл", index: "160000", pkbRegion: "ТУРКЕСТАНСКАЯ", localities: ["Туркестан", "Кентау", "Арыс", "Сарыагаш"] },
    { region: "Улытауская обл", index: "101500", pkbRegion: "УЛЫТАУСКАЯ", localities: ["Жезказган", "Сатпаев", "Каражал"] },
];

export const creditTransactions = [
    {
        description: "Выдано в кассу бухгалтерии",
        debet: "1010",
        credit: "1010",
        cashType: "cash_to_accounting",
    },
    {
        description: "Для покупки валюты в Банке",
        debet: "1251",
        credit: "1010",
        cashType: "deposit_to_bank",
    },
    {
        description: "Выдано в подотчет",
        debet: "1250",
        credit: "1010",
        cashType: "cash_to_employee",
    },
    // {
    // 	description: "Выдано в другой ОП",
    // 	debet: "1021",
    // 	credit: "1010",
    // 	cashType: "transfer_to_branch",
    // },
    {
        description: "Выдано в другой КО",
        debet: "1010",
        credit: "1010",
        cashType: "cash_to_cashbox",
    }
];

export const debetTransactions = [
    {
        description: "Получение из кассы бухгалтерии",
        debet: "1010",
        credit: "1010",
        cashType: "cash_from_accounting",
    },
    {
        description: "Получено из Банка",
        debet: "1010",
        credit: "1010",
        cashType: "withdrawal_from_bank",
    },
    {
        description: "Возврат подотчетника",
        debet: "1010",
        credit: "1251",
        cashType: "return_from_employee",
    },
    // {
    // 	description: "Получено из другого ОП",
    // 	debet: "1010",
    // 	credit: "1021",
    // 	cashType: "transfer_from_branch",
    // },
    // {
    // 	description: "Получено с другого КО",
    // 	debet: "1010",
    // 	credit: "1010",
    // 	cashType: "exchange_purchase",
    // }
];

export const currencyArray = [
    {
        code: "GOLD",
        description: "Золото"
    },
    {
        code: "RUB",
        description: "Российский рубль"
    },
    {
        code: "USD",
        description: "Доллар США"
    },
    {
        code: "EUR",
        description: "Евро"
    },
    {
        code: "KGS",
        description: "Кыргызский сом"
    },
    {
        code: "GBP",
        description: "Фунт стерлингов"
    },
    {
        code: "CNY",
        description: "Китайский юань"
    },
    {
        code: "CHF",
        description: "Швейцарский франк"
    },
    {
        code: "GEL",
        description: "Грузинский лари"
    },
    {
        code: "AED",
        description: "Дирхам ОАЭ"
    },
    {
        code: "INR",
        description: "Индийская рупия"
    },
    {
        code: "CAD",
        description: "Канадский доллар"
    },
    {
        code: "THB",
        description: "Тайский бат"
    },
    {
        code: "TRY",
        description: "Турецкая лира"
    },
    {
        code: "UZS",
        description: "Узбекский сум"
    },
    {
        code: "UAH",
        description: "Украинская гривна"
    },
    {
        code: "CZK",
        description: "Чешская крона"
    },
    {
        code: "ILS",
        description: "Новый израильский шекель"
    },
    {
        code: "KRW",
        description: "Южнокорейская вона"
    },
    {
        code: "JPY",
        description: "Японская иена"
    },
    {
        code: "AUD",
        description: "Австралийский доллар"
    },
    {
        code: "NZD",
        description: "Новозеландский доллар"
    },
    {
        code: "SGD",
        description: "Сингапурский доллар"
    },
    {
        code: "BRL",
        description: "Бразильский реал"
    },
    {
        code: "ZAR",
        description: "Южноафриканский рэнд"
    },
    {
        code: "MYR",
        description: "Малайзийский ринггит"
    },
    {
        code: "PLN",
        description: "Польский злотый"
    },
    {
        code: "MXN",
        description: "Мексиканское песо"
    },
    {
        code: "ARS",
        description: "Аргентинское песо"
    },
    {
        code: "SEK",
        description: "Шведская крона"
    },
    {
        code: "NOK",
        description: "Норвежская крона"
    },
    {
        code: "HKD",
        description: "Гонконгский доллар"
    },
    {
        code: "DKK",
        description: "Датская крона"
    },
    {
        code: "HUF",
        description: "Венгерский форинт"
    },
    {
        code: "IDR",
        description: "Индонезийская рупия"
    },
    {
        code: "PHP",
        description: "Филиппинское песо"
    },
    {
        code: "VND",
        description: "Вьетнамский донг"
    },
    {
        code: "EGP",
        description: "Египетский фунт"
    },
    {
        code: "MAD",
        description: "Марокканский дирхам"
    },
    {
        code: "NGN",
        description: "Нигерийская найра"
    },
    {
        code: "PKR",
        description: "Пакистанская рупия"
    },
    {
        code: "BDT",
        description: "Бангладешская така"
    },
    {
        code: "LKR",
        description: "Шри-ланкийская рупия"
    },
    {
        code: "CLP",
        description: "Чилийское песо"
    },
    {
        code: "COP",
        description: "Колумбийское песо"
    },
    {
        code: "PEN",
        description: "Перуанский соль"
    },
    {
        code: "SAR",
        description: "Саудовский риял"
    },
    {
        code: "ALL",
        description: "Албанский лек"
    },
    {
        code: "DZD",
        description: "Алжирский динар"
    },
    {
        code: "AOA",
        description: "Ангольская кванза"
    },
    {
        code: "AMD",
        description: "Армянский драм"
    },
    {
        code: "AWG",
        description: "Арубанский флорин"
    },
    {
        code: "AZN",
        description: "Азербайджанский манат"
    },
    {
        code: "BHD",
        description: "Бахрейнский динар"
    },
    {
        code: "BBD",
        description: "Барбадосский доллар"
    },
    {
        code: "BZD",
        description: "Белизский доллар"
    },
    {
        code: "BMD",
        description: "Бермудский доллар"
    },
    {
        code: "BTN",
        description: "Бутанский нгултрум"
    },
    {
        code: "BOB",
        description: "Боливийский боливиано"
    },
    {
        code: "BAM",
        description: "Боснийская марка"
    },
    {
        code: "BWP",
        description: "Ботсванская пула"
    },
    {
        code: "BND",
        description: "Брунейский доллар"
    },
    {
        code: "BGN",
        description: "Болгарский лев"
    },
    {
        code: "BIF",
        description: "Бурундийский франк"
    },
    {
        code: "CVE",
        description: "Эскудо Кабо-Верде"
    },
    {
        code: "KHR",
        description: "Камбоджийский риель"
    },
    {
        code: "XAF",
        description: "Франк КФА (Центральная Африка)"
    },
    {
        code: "XOF",
        description: "Франк КФА (Западная Африка)"
    },
    {
        code: "KMF",
        description: "Коморский франк"
    },
    {
        code: "CDF",
        description: "Конголезский франк"
    },
    {
        code: "CRC",
        description: "Коста-риканский колон"
    },
    {
        code: "CUP",
        description: "Кубинское песо"
    },
    {
        code: "DOP",
        description: "Доминиканское песо"
    },
    {
        code: "ETB",
        description: "Эфиопский быр"
    },
    {
        code: "FJD",
        description: "Фиджийский доллар"
    },
    {
        code: "GMD",
        description: "Гамбийский даласи"
    },
    {
        code: "GHS",
        description: "Ганский седи"
    },
    {
        code: "GTQ",
        description: "Гватемальский кетсаль"
    },
    {
        code: "GNF",
        description: "Гвинейский франк"
    },
    {
        code: "GYD",
        description: "Гайанский доллар"
    },
    {
        code: "HTG",
        description: "Гаитянский гурд"
    },
    {
        code: "HNL",
        description: "Гондурасская лемпира"
    },
    {
        code: "ISK",
        description: "Исландская крона"
    },
    {
        code: "IQD",
        description: "Иракский динар"
    },
    {
        code: "JMD",
        description: "Ямайский доллар"
    },
    {
        code: "JOD",
        description: "Иорданский динар"
    },
    {
        code: "KZT",
        description: "Казахстанский тенге"
    },
    {
        code: "KES",
        description: "Кенийский шиллинг"
    },
    {
        code: "KWD",
        description: "Кувейтский динар"
    },
    {
        code: "LAK",
        description: "Лаосский кип"
    },
    {
        code: "LBP",
        description: "Ливанский фунт"
    },
    {
        code: "LSL",
        description: "Лесотский лоти"
    },
    {
        code: "LRD",
        description: "Либерийский доллар"
    },
    {
        code: "LYD",
        description: "Ливийский динар"
    },
    {
        code: "MOP",
        description: "Макао патака"
    },
    {
        code: "MWK",
        description: "Малавийская квача"
    },
    {
        code: "MVR",
        description: "Мальдивская руфия"
    },
    {
        code: "MRO",
        description: "Мавританская угия"
    },
    {
        code: "MUR",
        description: "Маврикийская рупия"
    },
    {
        code: "MNT",
        description: "Монгольский тугрик"
    },
    {
        code: "MZN",
        description: "Мозамбикский метикал"
    },
    {
        code: "NAD",
        description: "Намибийский доллар"
    },
    {
        code: "NPR",
        description: "Непальская рупия"
    },
    {
        code: "NIO",
        description: "Никарагуанская кордоба"
    },
    {
        code: "OMR",
        description: "Оманский риал"
    },
    {
        code: "PGK",
        description: "Кина Папуа-Новой Гвинеи"
    },
    {
        code: "PYG",
        description: "Парагвайский гуарани"
    },
    {
        code: "QAR",
        description: "Катарский риал"
    },
    {
        code: "RON",
        description: "Румынский лей"
    },
    {
        code: "RWF",
        description: "Руандийский франк"
    },
    {
        code: "WST",
        description: "Самоанская тала"
    },
    {
        code: "STD",
        description: "Добра Сан-Томе и Принсипи"
    },
    {
        code: "SVC",
        description: "Сальвадорский колон"
    },
    {
        code: "SCR",
        description: "Сейшельская рупия"
    },
    {
        code: "SLL",
        description: "Сьерра-леонский леоне"
    },
    {
        code: "SOS",
        description: "Сомалийский шиллинг"
    },
    {
        code: "SZL",
        description: "Свазилендский лилангени"
    },
    {
        code: "SYP",
        description: "Сирийский фунт"
    },
    {
        code: "TJS",
        description: "Таджикский сомони"
    },
    {
        code: "TZS",
        description: "Танзанийский шиллинг"
    },
    {
        code: "TOP",
        description: "Паанга Тонга"
    },
    {
        code: "TTD",
        description: "Доллар Тринидада и Тобаго"
    },
    {
        code: "TND",
        description: "Тунисский динар"
    },
    {
        code: "TMT",
        description: "Туркменский манат"
    },
    {
        code: "UGX",
        description: "Угандийский шиллинг"
    },
    {
        code: "UYU",
        description: "Уругвайское песо"
    },
    {
        code: "VUV",
        description: "Вануату вату"
    },
    {
        code: "VEF",
        description: "Венесуэльский боливар"
    },
    {
        code: "YER",
        description: "Йеменский риал"
    },
    {
        code: "ZMW",
        description: "Замбийская квача"
    },
    {
        code: "ZWL",
        description: "Зимбабвийский доллар"
    }
];

export const COUNTRIES: Record<string, { name: string, code: string, fullName: string }> = {
    "ABH": {
        "name": "Абхазия",
        "code": "AB",
        "fullName": "Республика Абхазия"
    },
    "AUS": {
        "name": "Австралия",
        "code": "AU",
        "fullName": "Австралия"
    },
    "AUT": {
        "name": "Австрия",
        "code": "AT",
        "fullName": "Австрийская Республика"
    },
    "AZE": {
        "name": "Азербайджан",
        "code": "AZ",
        "fullName": "Республика Азербайджан"
    },
    "ALB": {
        "name": "Албания",
        "code": "AL",
        "fullName": "Республика Албания"
    },
    "DZA": {
        "name": "Алжир",
        "code": "DZ",
        "fullName": "Алжирская Народная Демократическая Республика"
    },
    "ASM": {
        "name": "Американское Самоа",
        "code": "AS",
        "fullName": "Американское Самоа"
    },
    "AIA": {
        "name": "Ангилья",
        "code": "AI",
        "fullName": "Ангилья"
    },
    "AGO": {
        "name": "Ангола",
        "code": "AO",
        "fullName": "Республика Ангола"
    },
    "AND": {
        "name": "Андорра",
        "code": "AD",
        "fullName": "Княжество Андорра"
    },
    "ATA": {
        "name": "Антарктида",
        "code": "AQ",
        "fullName": "Антарктида"
    },
    "ATG": {
        "name": "Антигуа и Барбуда",
        "code": "AG",
        "fullName": "Антигуа и Барбуда"
    },
    "ARG": {
        "name": "Аргентина",
        "code": "AR",
        "fullName": "Аргентинская Республика"
    },
    "ARM": {
        "name": "Армения",
        "code": "AM",
        "fullName": "Республика Армения"
    },
    "ABW": {
        "name": "Аруба",
        "code": "AW",
        "fullName": "Аруба"
    },
    "AFG": {
        "name": "Афганистан",
        "code": "AF",
        "fullName": "Переходное Исламское Государство Афганистан"
    },
    "BHS": {
        "name": "Багамы",
        "code": "BS",
        "fullName": "Содружество Багамы"
    },
    "BGD": {
        "name": "Бангладеш",
        "code": "BD",
        "fullName": "Народная Республика Бангладеш"
    },
    "BRB": {
        "name": "Барбадос",
        "code": "BB",
        "fullName": "Барбадос"
    },
    "BHR": {
        "name": "Бахрейн",
        "code": "BH",
        "fullName": "Королевство Бахрейн"
    },
    "BLR": {
        "name": "Беларусь",
        "code": "BY",
        "fullName": "Республика Беларусь"
    },
    "BLZ": {
        "name": "Белиз",
        "code": "BZ",
        "fullName": "Белиз"
    },
    "BEL": {
        "name": "Бельгия",
        "code": "BE",
        "fullName": "Королевство Бельгии"
    },
    "BEN": {
        "name": "Бенин",
        "code": "BJ",
        "fullName": "Республика Бенин"
    },
    "BMU": {
        "name": "Бермуды",
        "code": "BM",
        "fullName": "Бермуды"
    },
    "BGR": {
        "name": "Болгария",
        "code": "BG",
        "fullName": "Республика Болгария"
    },
    "BOL": {
        "name": "Боливия, Многонациональное Государство",
        "code": "BO",
        "fullName": "Многонациональное Государство Боливия"
    },
    "BES": {
        "name": "Бонайре, Саба и Синт-Эстатиус",
        "code": "BQ",
        "fullName": "Бонайре, Саба и Синт-Эстатиус"
    },
    "BIH": {
        "name": "Босния и Герцеговина",
        "code": "BA",
        "fullName": "Босния и Герцеговина"
    },
    "BWA": {
        "name": "Ботсвана",
        "code": "BW",
        "fullName": "Республика Ботсвана"
    },
    "BRA": {
        "name": "Бразилия",
        "code": "BR",
        "fullName": "Федеративная Республика Бразилия"
    },
    "IOT": {
        "name": "Британская территория в Индийском океане",
        "code": "IO",
        "fullName": "Британская территория в Индийском океане"
    },
    "BRN": {
        "name": "Бруней-Даруссалам",
        "code": "BN",
        "fullName": "Бруней-Даруссалам"
    },
    "BFA": {
        "name": "Буркина-Фасо",
        "code": "BF",
        "fullName": "Буркина-Фасо"
    },
    "BDI": {
        "name": "Бурунди",
        "code": "BI",
        "fullName": "Республика Бурунди"
    },
    "BTN": {
        "name": "Бутан",
        "code": "BT",
        "fullName": "Королевство Бутан"
    },
    "VUT": {
        "name": "Вануату",
        "code": "VU",
        "fullName": "Республика Вануату"
    },
    "HUN": {
        "name": "Венгрия",
        "code": "HU",
        "fullName": "Венгерская Республика"
    },
    "VEN": {
        "name": "Венесуэла Боливарианская Республика",
        "code": "VE",
        "fullName": "Боливарийская Республика Венесуэла"
    },
    "VGB": {
        "name": "Виргинские острова, Британские",
        "code": "VG",
        "fullName": "Британские Virgin острова"
    },
    "VIR": {
        "name": "Виргинские острова, США",
        "code": "VI",
        "fullName": "Виргинские острова Соединенных Штатов"
    },
    "VNM": {
        "name": "Вьетнам",
        "code": "VN",
        "fullName": "Социалистическая Республика Вьетнам"
    },
    "GAB": {
        "name": "Габон",
        "code": "GA",
        "fullName": "Габонская Республика"
    },
    "HTI": {
        "name": "Гаити",
        "code": "HT",
        "fullName": "Республика Гаити"
    },
    "GUY": {
        "name": "Гайана",
        "code": "GY",
        "fullName": "Республика Гайана"
    },
    "GMB": {
        "name": "Гамбия",
        "code": "GM",
        "fullName": "Республика Гамбия"
    },
    "GHA": {
        "name": "Гана",
        "code": "GH",
        "fullName": "Республика Гана"
    },
    "GLP": {
        "name": "Гваделупа",
        "code": "GP",
        "fullName": "Гваделупа"
    },
    "GTM": {
        "name": "Гватемала",
        "code": "GT",
        "fullName": "Республика Гватемала"
    },
    "GIN": {
        "name": "Гвинея",
        "code": "GN",
        "fullName": "Гвинейская Республика"
    },
    "GNB": {
        "name": "Гвинея-Бисау",
        "code": "GW",
        "fullName": "Республика Гвинея-Бисау"
    },
    "DEU": {
        "name": "Германия",
        "code": "DE",
        "fullName": "Федеративная Республика Германия"
    },
    "GGY": {
        "name": "Гернси",
        "code": "GG",
        "fullName": "Гернси"
    },
    "GIB": {
        "name": "Гибралтар",
        "code": "GI",
        "fullName": "Гибралтар"
    },
    "HND": {
        "name": "Гондурас",
        "code": "HN",
        "fullName": "Республика Гондурас"
    },
    "HKG": {
        "name": "Гонконг",
        "code": "HK",
        "fullName": "Специальный административный регион Китая Гонконг"
    },
    "GRD": {
        "name": "Гренада",
        "code": "GD",
        "fullName": "Гренада"
    },
    "GRL": {
        "name": "Гренландия",
        "code": "GL",
        "fullName": "Гренландия"
    },
    "GRC": {
        "name": "Греция",
        "code": "GR",
        "fullName": "Греческая Республика"
    },
    "GEO": {
        "name": "Грузия",
        "code": "GE",
        "fullName": "Грузия"
    },
    "GUM": {
        "name": "Гуам",
        "code": "GU",
        "fullName": "Гуам"
    },
    "DNK": {
        "name": "Дания",
        "code": "DK",
        "fullName": "Королевство Дания"
    },
    "JEY": {
        "name": "Джерси",
        "code": "JE",
        "fullName": "Джерси"
    },
    "DJI": {
        "name": "Джибути",
        "code": "DJ",
        "fullName": "Республика Джибути"
    },
    "DMA": {
        "name": "Доминика",
        "code": "DM",
        "fullName": "Содружество Доминики"
    },
    "DOM": {
        "name": "Доминиканская Республика",
        "code": "DO",
        "fullName": "Доминиканская Республика"
    },
    "EGY": {
        "name": "Египет",
        "code": "EG",
        "fullName": "Арабская Республика Египет"
    },
    "ZMB": {
        "name": "Замбия",
        "code": "ZM",
        "fullName": "Республика Замбия"
    },
    "ESH": {
        "name": "Западная Сахара",
        "code": "EH",
        "fullName": "Западная Сахара"
    },
    "ZWE": {
        "name": "Зимбабве",
        "code": "ZW",
        "fullName": "Республика Зимбабве"
    },
    "ISR": {
        "name": "Израиль",
        "code": "IL",
        "fullName": "Государство Израиль"
    },
    "IND": {
        "name": "Индия",
        "code": "IN",
        "fullName": "Республика Индия"
    },
    "IDN": {
        "name": "Индонезия",
        "code": "ID",
        "fullName": "Республика Индонезия"
    },
    "JOR": {
        "name": "Иордания",
        "code": "JO",
        "fullName": "Иорданское Хашимитское Королевство"
    },
    "IRQ": {
        "name": "Ирак",
        "code": "IQ",
        "fullName": "Республика Ирак"
    },
    "IRN": {
        "name": "Иран, Исламская Республика",
        "code": "IR",
        "fullName": "Исламская Республика Иран"
    },
    "IRL": {
        "name": "Ирландия",
        "code": "IE",
        "fullName": "Ирландия"
    },
    "ISL": {
        "name": "Исландия",
        "code": "IS",
        "fullName": "Республика Исландия"
    },
    "ESP": {
        "name": "Испания",
        "code": "ES",
        "fullName": "Королевство Испания"
    },
    "ITA": {
        "name": "Италия",
        "code": "IT",
        "fullName": "Итальянская Республика"
    },
    "YEM": {
        "name": "Йемен",
        "code": "YE",
        "fullName": "Йеменская Республика"
    },
    "CPV": {
        "name": "Кабо-Верде",
        "code": "CV",
        "fullName": "Республика Кабо-Верде"
    },
    "KAZ": {
        "name": "Казахстан",
        "code": "KZ",
        "fullName": "Республика Казахстан"
    },
    "KHM": {
        "name": "Камбоджа",
        "code": "KH",
        "fullName": "Королевство Камбоджа"
    },
    "CMR": {
        "name": "Камерун",
        "code": "CM",
        "fullName": "Республика Камерун"
    },
    "CAN": {
        "name": "Канада",
        "code": "CA",
        "fullName": "Канада"
    },
    "QAT": {
        "name": "Катар",
        "code": "QA",
        "fullName": "Государство Катар"
    },
    "KEN": {
        "name": "Кения",
        "code": "KE",
        "fullName": "Республика Кения"
    },
    "CYP": {
        "name": "Кипр",
        "code": "CY",
        "fullName": "Республика Кипр"
    },
    "KGZ": {
        "name": "Киргизия",
        "code": "KG",
        "fullName": "Киргизская Республика"
    },
    "KIR": {
        "name": "Кирибати",
        "code": "KI",
        "fullName": "Республика Кирибати"
    },
    "CHN": {
        "name": "Китай",
        "code": "CN",
        "fullName": "Китайская Народная Республика"
    },
    "CCK": {
        "name": "Кокосовые (Килинг) острова",
        "code": "CC",
        "fullName": "Кокосовые (Килинг) острова"
    },
    "COL": {
        "name": "Колумбия",
        "code": "CO",
        "fullName": "Республика Колумбия"
    },
    "COM": {
        "name": "Коморы",
        "code": "KM",
        "fullName": "Союз Коморы"
    },
    "COG": {
        "name": "Конго",
        "code": "CG",
        "fullName": "Республика Конго"
    },
    "COD": {
        "name": "Конго, Демократическая Республика",
        "code": "CD",
        "fullName": "Демократическая Республика Конго"
    },
    "PRK": {
        "name": "Корея, Народно-Демократическая Республика",
        "code": "KP",
        "fullName": "Корейская Народно-Демократическая Республика"
    },
    "KOR": {
        "name": "Корея, Республика",
        "code": "KR",
        "fullName": "Республика Корея"
    },
    "CRI": {
        "name": "Коста-Рика",
        "code": "CR",
        "fullName": "Республика Коста-Рика"
    },
    "CIV": {
        "name": "Кот д'Ивуар",
        "code": "CI",
        "fullName": "Республика Кот д'Ивуар"
    },
    "CUB": {
        "name": "Куба",
        "code": "CU",
        "fullName": "Республика Куба"
    },
    "KWT": {
        "name": "Кувейт",
        "code": "KW",
        "fullName": "Государство Кувейт"
    },
    "CUW": {
        "name": "Кюрасао",
        "code": "CW",
        "fullName": "Кюрасао"
    },
    "LAO": {
        "name": "Лаос",
        "code": "LA",
        "fullName": "Лаосская Народно-Демократическая Республика"
    },
    "LVA": {
        "name": "Латвия",
        "code": "LV",
        "fullName": "Латвийская Республика"
    },
    "LSO": {
        "name": "Лесото",
        "code": "LS",
        "fullName": "Королевство Лесото"
    },
    "LBN": {
        "name": "Ливан",
        "code": "LB",
        "fullName": "Ливанская Республика"
    },
    "LBY": {
        "name": "Ливийская Арабская Джамахирия",
        "code": "LY",
        "fullName": "Социалистическая Народная Ливийская Арабская Джамахирия"
    },
    "LBR": {
        "name": "Либерия",
        "code": "LR",
        "fullName": "Республика Либерия"
    },
    "LIE": {
        "name": "Лихтенштейн",
        "code": "LI",
        "fullName": "Княжество Лихтенштейн"
    },
    "LTU": {
        "name": "Литва",
        "code": "LT",
        "fullName": "Литовская Республика"
    },
    "LUX": {
        "name": "Люксембург",
        "code": "LU",
        "fullName": "Великое Герцогство Люксембург"
    },
    "BUS": {
        "name": "Маврикий",
        "code": "MU",
        "fullName": "Республика Маврикий"
    },
    "MRT": {
        "name": "Мавритания",
        "code": "MR",
        "fullName": "Исламская Республика Мавритания"
    },
    "MDG": {
        "name": "Мадагаскар",
        "code": "MG",
        "fullName": "Республика Мадагаскар"
    },
    "MYT": {
        "name": "Майотта",
        "code": "YT",
        "fullName": "Майотта"
    },
    "MAC": {
        "name": "Макао",
        "code": "MO",
        "fullName": "Специальный административный регион Китая Макао"
    },
    "MWI": {
        "name": "Малави",
        "code": "MW",
        "fullName": "Республика Малави"
    },
    "MYS": {
        "name": "Малайзия",
        "code": "MY",
        "fullName": "Малайзия"
    },
    "MLI": {
        "name": "Мали",
        "code": "ML",
        "fullName": "Республика Мали"
    },
    "UMI": {
        "name": "Малые Тихоокеанские отдаленные острова Соединенных Штатов",
        "code": "UM",
        "fullName": "Малые Тихоокеанские отдаленные острова Соединенных Штатов"
    },
    "MDV": {
        "name": "Мальдивы",
        "code": "MV",
        "fullName": "Мальдивская Республика"
    },
    "MLT": {
        "name": "Мальта",
        "code": "MT",
        "fullName": "Республика Мальта"
    },
    "MAR": {
        "name": "Марокко",
        "code": "MA",
        "fullName": "Королевство Марокко"
    },
    "MTQ": {
        "name": "Мартиника",
        "code": "MQ",
        "fullName": "Мартиника"
    },
    "MHL": {
        "name": "Маршалловы острова",
        "code": "MH",
        "fullName": "Республика Маршалловы острова"
    },
    "MEX": {
        "name": "Мексика",
        "code": "MX",
        "fullName": "Мексиканские Соединенные Штаты"
    },
    "FSM": {
        "name": "Микронезия, Федеративные Штаты",
        "code": "FM",
        "fullName": "Федеративные штаты Микронезии"
    },
    "MOZ": {
        "name": "Мозамбик",
        "code": "MZ",
        "fullName": "Республика Мозамбик"
    },
    "MDA": {
        "name": "Молдова, Республика",
        "code": "MD",
        "fullName": "Республика Молдова"
    },
    "MCO": {
        "name": "Монако",
        "code": "MC",
        "fullName": "Княжество Монако"
    },
    "MNG": {
        "name": "Монголия",
        "code": "MN",
        "fullName": "Монголия"
    },
    "MSR": {
        "name": "Монтсеррат",
        "code": "MS",
        "fullName": "Монтсеррат"
    },
    "MMR": {
        "name": "Мьянма",
        "code": "MM",
        "fullName": "Союз Мьянма"
    },
    "NAM": {
        "name": "Намибия",
        "code": "NA",
        "fullName": "Республика Намибия"
    },
    "NRU": {
        "name": "Науру",
        "code": "NR",
        "fullName": "Республика Науру"
    },
    "NPL": {
        "name": "Непал",
        "code": "NP",
        "fullName": "Королевство Непал"
    },
    "NER": {
        "name": "Нигер",
        "code": "NE",
        "fullName": "Республика Нигер"
    },
    "NGA": {
        "name": "Нигерия",
        "code": "NG",
        "fullName": "Федеративная Республика Нигерия"
    },
    "NLD": {
        "name": "Нидерланды",
        "code": "NL",
        "fullName": "Королевство Нидерландов"
    },
    "NIC": {
        "name": "Никарагуа",
        "code": "NI",
        "fullName": "Республика Никарагуа"
    },
    "NIU": {
        "name": "Ниуэ",
        "code": "NU",
        "fullName": "Республика Ниуэ"
    },
    "NZL": {
        "name": "Новая Зеландия",
        "code": "NZ",
        "fullName": "Новая Зеландия"
    },
    "NCL": {
        "name": "Новая Каледония",
        "code": "NC",
        "fullName": "Новая Каледония"
    },
    "NOR": {
        "name": "Норвегия",
        "code": "NO",
        "fullName": "Королевство Норвегия"
    },
    "ARE": {
        "name": "Объединенные Арабские Эмираты",
        "code": "AE",
        "fullName": "Объединенные Арабские Эмираты"
    },
    "OMN": {
        "name": "Оман",
        "code": "OM",
        "fullName": "Султанат Оман"
    },
    "BVT": {
        "name": "Остров Буве",
        "code": "BV",
        "fullName": "Остров Буве"
    },
    "IMN": {
        "name": "Остров Мэн",
        "code": "IM",
        "fullName": "Остров Мэн"
    },
    "NFK": {
        "name": "Остров Норфолк",
        "code": "NF",
        "fullName": "Остров Норфолк"
    },
    "CXR": {
        "name": "Остров Рождества",
        "code": "CX",
        "fullName": "Остров Рождества"
    },
    "HMD": {
        "name": "Остров Херд и острова Макдональд",
        "code": "HM",
        "fullName": "Остров Херд и острова Макдональд"
    },
    "CYM": {
        "name": "Острова Кайман",
        "code": "KY",
        "fullName": "Острова Кайман"
    },
    "COK": {
        "name": "Острова Кука",
        "code": "CK",
        "fullName": "Острова Кука"
    },
    "TCA": {
        "name": "Острова Теркс и Кайкос",
        "code": "TC",
        "fullName": "Острова Теркс и Кайкос"
    },
    "PAK": {
        "name": "Пакистан",
        "code": "PK",
        "fullName": "Исламская Республика Пакистан"
    },
    "PLW": {
        "name": "Палау",
        "code": "PW",
        "fullName": "Республика Палау"
    },
    "PSE": {
        "name": "Палестинская территория, оккупированная",
        "code": "PS",
        "fullName": "Оккупированная Палестинская территория"
    },
    "PAN": {
        "name": "Панама",
        "code": "PA",
        "fullName": "Республика Панама"
    },
    "VAT": {
        "name": "Папский Престол (Государство — город Ватикан)",
        "code": "VA",
        "fullName": "Папский Престол (Государство — город Ватикан)"
    },
    "PNG": {
        "name": "Папуа-Новая Гвинея",
        "code": "PG",
        "fullName": "Папуа-Новая Гвинея"
    },
    "PRY": {
        "name": "Парагвай",
        "code": "PY",
        "fullName": "Республика Парагвай"
    },
    "PER": {
        "name": "Перу",
        "code": "PE",
        "fullName": "Республика Перу"
    },
    "PCN": {
        "name": "Питкерн",
        "code": "PN",
        "fullName": "Питкерн"
    },
    "POL": {
        "name": "Польша",
        "code": "PL",
        "fullName": "Республика Польша"
    },
    "PRT": {
        "name": "Португалия",
        "code": "PT",
        "fullName": "Португальская Республика"
    },
    "PRI": {
        "name": "Пуэрто-Рико",
        "code": "PR",
        "fullName": "Пуэрто-Рико"
    },
    "MKD": {
        "name": "Республика Македония",
        "code": "MK",
        "fullName": "Республика Македония"
    },
    "REU": {
        "name": "Реюньон",
        "code": "RE",
        "fullName": "Реюньон"
    },
    "RUS": {
        "name": "Россия",
        "code": "RU",
        "fullName": "Российская Федерация"
    },
    "RWA": {
        "name": "Руанда",
        "code": "RW",
        "fullName": "Руандийская Республика"
    },
    "ROU": {
        "name": "Румыния",
        "code": "RO",
        "fullName": "Румыния"
    },
    "WSM": {
        "name": "Самоа",
        "code": "WS",
        "fullName": "Независимое Государство Самоа"
    },
    "SMR": {
        "name": "Сан-Марино",
        "code": "SM",
        "fullName": "Республика Сан-Марино"
    },
    "STP": {
        "name": "Сан-Томе и Принсипи",
        "code": "ST",
        "fullName": "Демократическая Республика Сан-Томе и Принсипи"
    },
    "SAU": {
        "name": "Саудовская Аравия",
        "code": "SA",
        "fullName": "Королевство Саудовская Аравия"
    },
    "SHN": {
        "name": "Святая Елена, Остров вознесения, Тристан-да-Кунья",
        "code": "SH",
        "fullName": "Святая Елена, Остров вознесения, Тристан-да-Кунья"
    },
    "MNP": {
        "name": "Северные Марианские острова",
        "code": "MP",
        "fullName": "Содружество Северных Марианских островов"
    },
    "BLM": {
        "name": "Сен-Бартельми",
        "code": "BL",
        "fullName": "Сен-Бартельми"
    },
    "MAF": {
        "name": "Сен-Мартен",
        "code": "MF",
        "fullName": "Сен-Мартен"
    },
    "SEN": {
        "name": "Сенегал",
        "code": "SN",
        "fullName": "Республика Сенегал"
    },
    "VCT": {
        "name": "Сент-Винсент и Гренадины",
        "code": "VC",
        "fullName": "Сент-Винсент и Гренадины"
    },
    "KNA": {
        "name": "Сент-Китс и Невис",
        "code": "KN",
        "fullName": "Сент-Китс и Невис"
    },
    "LCA": {
        "name": "Сент-Люсия",
        "code": "LC",
        "fullName": "Сент-Люсия"
    },
    "SPM": {
        "name": "Сент-Пьер и Микелон",
        "code": "PM",
        "fullName": "Сент-Пьер и Микелон"
    },
    "SRB": {
        "name": "Сербия",
        "code": "RS",
        "fullName": "Республика Сербия"
    },
    "SYC": {
        "name": "Сейшелы",
        "code": "SC",
        "fullName": "Республика Сейшелы"
    },
    "SGP": {
        "name": "Сингапур",
        "code": "SG",
        "fullName": "Республика Сингапур"
    },
    "SXM": {
        "name": "Синт-Мартен",
        "code": "SX",
        "fullName": "Синт-Мартен"
    },
    "SYR": {
        "name": "Сирийская Арабская Республика",
        "code": "SY",
        "fullName": "Сирийская Арабская Республика"
    },
    "SVK": {
        "name": "Словакия",
        "code": "SK",
        "fullName": "Словацкая Республика"
    },
    "SVN": {
        "name": "Словения",
        "code": "SI",
        "fullName": "Республика Словения"
    },
    "GBR": {
        "name": "Соединенное Королевство",
        "code": "GB",
        "fullName": "Соединенное Королевство Великобритании и Северной Ирландии"
    },
    "USA": {
        "name": "Соединенные Штаты",
        "code": "US",
        "fullName": "Соединенные Штаты Америки"
    },
    "SLB": {
        "name": "Соломоновы острова",
        "code": "SB",
        "fullName": "Соломоновы острова"
    },
    "SOM": {
        "name": "Сомали",
        "code": "SO",
        "fullName": "Сомалийская Республика"
    },
    "SDN": {
        "name": "Судан",
        "code": "SD",
        "fullName": "Республика Судан"
    },
    "SUR": {
        "name": "Суринам",
        "code": "SR",
        "fullName": "Республика Суринам"
    },
    "SLE": {
        "name": "Сьерра-Леоне",
        "code": "SL",
        "fullName": "Республика Сьерра-Леоне"
    },
    "TJK": {
        "name": "Таджикистан",
        "code": "TJ",
        "fullName": "Республика Таджикистан"
    },
    "THA": {
        "name": "Таиланд",
        "code": "TH",
        "fullName": "Королевство Таиланд"
    },
    "TWN": {
        "name": "Тайвань (Китай)",
        "code": "TW",
        "fullName": "Тайвань (Китай)"
    },
    "TZA": {
        "name": "Танзания, Объединенная Республика",
        "code": "TZ",
        "fullName": "Объединенная Республика Танзания"
    },
    "TLS": {
        "name": "Тимор-Лесте",
        "code": "TL",
        "fullName": "Демократическая Республика Timor-Лесте"
    },
    "TGO": {
        "name": "Того",
        "code": "TG",
        "fullName": "Тоголезская Республика"
    },
    "TKL": {
        "name": "Токелау",
        "code": "TK",
        "fullName": "Токелау"
    },
    "TON": {
        "name": "Тонга",
        "code": "TO",
        "fullName": "Королевство Тонга"
    },
    "TTO": {
        "name": "Тринидад и Тобаго",
        "code": "TT",
        "fullName": "Республика Тринидад и Тобаго"
    },
    "TUV": {
        "name": "Тувалу",
        "code": "TV",
        "fullName": "Тувалу"
    },
    "TUN": {
        "name": "Тунис",
        "code": "TN",
        "fullName": "Тунисская Республика"
    },
    "TKM": {
        "name": "Туркмения",
        "code": "TM",
        "fullName": "Туркменистан"
    },
    "TUR": {
        "name": "Турция",
        "code": "TR",
        "fullName": "Турецкая Республика"
    },
    "UGA": {
        "name": "Уганда",
        "code": "UG",
        "fullName": "Республика Уганда"
    },
    "UZB": {
        "name": "Узбекистан",
        "code": "UZ",
        "fullName": "Республика Узбекистан"
    },
    "UKR": {
        "name": "Украина",
        "code": "UA",
        "fullName": "Украина"
    },
    "WLF": {
        "name": "Уоллис и Футуна",
        "code": "WF",
        "fullName": "Уоллис и Футуна"
    },
    "URY": {
        "name": "Уругвай",
        "code": "UY",
        "fullName": "Восточная Республика Уругвай"
    },
    "FRO": {
        "name": "Фарерские острова",
        "code": "FO",
        "fullName": "Фарерские острова"
    },
    "FJI": {
        "name": "Фиджи",
        "code": "FJ",
        "fullName": "Республика островов Фиджи"
    },
    "PHL": {
        "name": "Филиппины",
        "code": "PH",
        "fullName": "Республика Филиппины"
    },
    "FIN": {
        "name": "Финляндия",
        "code": "FI",
        "fullName": "Финляндская Республика"
    },
    "FLK": {
        "name": "Фолклендские острова (Мальвинские)",
        "code": "FK",
        "fullName": "Фолклендские острова (Мальвинские)"
    },
    "FRA": {
        "name": "Франция",
        "code": "FR",
        "fullName": "Французская Республика"
    },
    "GUF": {
        "name": "Французская Гвиана",
        "code": "GF",
        "fullName": "Французская Гвиана"
    },
    "PYF": {
        "name": "Французская Полинезия",
        "code": "PF",
        "fullName": "Французская Полинезия"
    },
    "ATF": {
        "name": "Французские Южные территории",
        "code": "TF",
        "fullName": "Французские Южные территории"
    },
    "HRV": {
        "name": "Хорватия",
        "code": "HR",
        "fullName": "Республика Хорватия"
    },
    "CAF": {
        "name": "Центрально-Африканская Республика",
        "code": "CF",
        "fullName": "Центрально-Африканская Республика"
    },
    "TCD": {
        "name": "Чад",
        "code": "TD",
        "fullName": "Республика Чад"
    },
    "MNE": {
        "name": "Черногория",
        "code": "ME",
        "fullName": "Республика Черногория"
    },
    "CZE": {
        "name": "Чешская Республика",
        "code": "CZ",
        "fullName": "Чешская Республика"
    },
    "CHL": {
        "name": "Чили",
        "code": "CL",
        "fullName": "Республика Чили"
    },
    "CHE": {
        "name": "Швейцария",
        "code": "CH",
        "fullName": "Швейцарская Конфедерация"
    },
    "SWE": {
        "name": "Швеция",
        "code": "SE",
        "fullName": "Королевство Швеция"
    },
    "SJM": {
        "name": "Шпицберген и Ян Майен",
        "code": "SJ",
        "fullName": "Шпицберген и Ян Майен"
    },
    "LKA": {
        "name": "Шри-Ланка",
        "code": "LK",
        "fullName": "Демократическая Социалистическая Республика Шри-Ланка"
    },
    "ECU": {
        "name": "Эквадор",
        "code": "EC",
        "fullName": "Республика Эквадор"
    },
    "GNQ": {
        "name": "Экваториальная Гвинея",
        "code": "GQ",
        "fullName": "Республика Экваториальная Гвинея"
    },
    "ALA": {
        "name": "Эландские острова",
        "code": "AX",
        "fullName": "Эландские острова"
    },
    "SLV": {
        "name": "Эль-Сальвадор",
        "code": "SV",
        "fullName": "Республика Эль-Сальвадор"
    },
    "ERI": {
        "name": "Эритрея",
        "code": "ER",
        "fullName": "Эритрея"
    },
    "SWZ": {
        "name": "Эсватини",
        "code": "SZ",
        "fullName": "Королевство Эсватини"
    },
    "EST": {
        "name": "Эстония",
        "code": "EE",
        "fullName": "Эстонская Республика"
    },
    "ETH": {
        "name": "Эфиопия",
        "code": "ET",
        "fullName": "Федеративная Демократическая Республика Эфиопия"
    },
    "ZAF": {
        "name": "Южная Африка",
        "code": "ZA",
        "fullName": "Южно-Африканская Республика"
    },
    "SGS": {
        "name": "Южная Джорджия и Южные Сандвичевы острова",
        "code": "GS",
        "fullName": "Южная Джорджия и Южные Сандвичевы острова"
    },
    "OST": {
        "name": "Южная Осетия",
        "code": "OS",
        "fullName": "Республика Южная Осетия"
    },
    "SSD": {
        "name": "Южный Судан",
        "code": "SS",
        "fullName": "Южный Судан"
    },
    "JAM": {
        "name": "Ямайка",
        "code": "JM",
        "fullName": "Ямайка"
    },
    "JPN": {
        "name": "Япония",
        "code": "JP",
        "fullName": "Япония"
    }
};